import React from 'react';
import axios from 'axios';

export const unauthHeaders = {
    Accept: 'application/json; charset=utf-8',
    'Content-Type': 'application/json',
    Project: "Medis"
};

export const authHeaders = {
    Authorization: `Bearer ${sessionStorage.getItem('token')}`,
    Accept: 'application/json; charset=utf-8',
    'Content-Type': 'application/json',
};

export const refresh = () => {
    if (!sessionStorage.getItem('token')) {
        window.location = `${process.env.REACT_APP_WEBSITE_NAME}/`;
        return;
    }
    const authTokenRequest = axios.post(`${process.env.REACT_APP_API}api/v1.0/auth/token/refresh`, {
        Token: sessionStorage.getItem('token'),
        RefreshToken: sessionStorage.getItem('refreshToken'),
    }, {
        headers: {
            ...unauthHeaders,
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        }
    })
        .then((res) => {
            sessionStorage.setItem('token', res.data.token);
            sessionStorage.setItem('refreshToken', res.data.refreshToken);
            if (localStorage.getItem('refreshToken')) {
                localStorage.setItem('refreshToken', res.data.refreshToken);
            }
        })
        .catch((err) => {
            console.log(err);
            localStorage.clear();
            sessionStorage.clear();
            window.location = `${process.env.REACT_APP_WEBSITE_NAME}/`;
        });
    return authTokenRequest;
}


axios.interceptors.response.use((response) => {
    return response;
}, function (error) {
    // Do something with response error
    if (error.response.status === 401) {
        refresh().then(response => {
            // update the error config with new token
            error.config.__isRetryRequest = true;
            error.config.headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
            window.location = window.location.href;
        })
    } else {
        return Promise.reject(error);
    }
});
